import {
  Card,
  CardContent,
} from '@eriko/ui/src/components/ui/card';

export function SummaryTextView({ summary }: { summary: string }) {
  return (
    <Card>
      <CardContent className="p-3">
        <p className="text-sm leading-relaxed">{summary}</p>
      </CardContent>
    </Card>
  );
}
